import * as types from "../actions/actionTypes";
import intialState from "./initialState";

const handles = {
  [types.TOKEN_GET_STARTED]: (state, tokenId) => ({
    ...state,
    [tokenId]: { isLoading: true },
  }),
  [types.TOKEN_GET_REJECTED]: (state, { tokenId, message }) => ({
    ...state,
    [tokenId]: { error: message },
  }),
  [types.TOKEN_GET_FULFILLED]: (state, { token }) => ({
    ...state,
    [token.token]: token,
  }),
};

export default function tokenReducer(state = intialState.tokens, action) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
